// extracted by mini-css-extract-plugin
module.exports = {"button":"pseudoButton-module--button--13T2B","fontsLoading":"pseudoButton-module--fonts-loading--21yZq"};